import { styled } from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const EmptyState = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 80px;
    flex-direction: column;
    gap: 16px;
`;

export const EmptyStateTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const EmptyStateTitle = styled.span`
    ${mixins.setFontVariant("subtitle1", colorsPalettes.carbon["500"])};
`;

export const EmptyStateSubtitle = styled.span`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon["300"])};
`;
